import { SCOPES } from '../lib/searchScope';
import type { SearchScope } from '../lib/searchScope';

/** Quick silo switch: All / Customers / Jobs / Suppliers. */
export function SearchScopeToggle({
  value,
  onChange,
  counts,
  size = 'md',
  className = '',
}: {
  value: SearchScope;
  onChange: (next: SearchScope) => void;
  /** Optional per-scope counts shown beside the label. */
  counts?: Partial<Record<SearchScope, number>>;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <div className={`gsl-seg ${size === 'sm' ? 'gsl-seg-sm' : ''} ${className}`} role="group" aria-label="Search scope">
      {SCOPES.map((s) => (
        <button
          key={s.id}
          type="button"
          aria-pressed={value === s.id}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onChange(s.id)}
        >
          {s.label}
          {counts && typeof counts[s.id] === 'number' ? <span className="gsl-num opacity-70">{counts[s.id]}</span> : null}
        </button>
      ))}
    </div>
  );
}
